<template>
  <div class="dropdown-wrapper" ref="dropdown">
    <div class="dropdown-container" @click="toggleDropdown">
      <div class="dropdown-display">{{ selected ? $t(selected.text) : 'Select an option' }}</div>
      <span class="dropdown-arrow" :class="{ rotate: isOpen }">&#9662;</span>
    </div>
    <ul v-if="isOpen" class="dropdown-list">
      <li
          v-for="(option, index) in options"
          :key="index"
          @click="selectOption(option)"
          :class="{ selected: selected && selected.value === option.value }"
          class="dropdown-item"
      >
        {{ $t(option.text) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MinimalDropdown",
  props: {
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    defaultValue: {
      type: String, // Only value will be passed (e.g., 'banana')
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      selected: null, // Store the selected option object
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.selected = option;
      this.isOpen = false;
      this.$emit("change", option);
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
    setDefaultSelection() {
      if (this.defaultValue) {
        const matchingOption = this.options.find(
            (option) => option.value === this.defaultValue
        );
        if (matchingOption) {
          this.selected = matchingOption;
        }
      }
    },
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler() {
        this.setDefaultSelection();
      },
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
/* Add your dropdown styles here */
.dropdown-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.dropdown-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  background: #fff;
}

.dropdown-container:hover {
  border-color: rgba(0,0,0,0.5);
}

.dropdown-display {
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dropdown-arrow {
  transition: transform 0.3s ease;
}

.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  padding: 0;
  margin: 0;
}

.dropdown-item {
  list-style: none;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dropdown-item:hover {
  background: rgba(0,0,0,0.5);
  color: #fff;
}

.dropdown-item.selected {
  background: rgba(0,0,0,0.5);
  color: #fff;
}
</style>
